import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { ImageSchema } from 'images'
import { ChildrenSchema } from 'utils'

import ScoreSchema from '../../schemas/ScoreSchema'
import TeamButton from '../TeamButton'

import styles from './index.css'

class MatchScore extends PureComponent {
  shouldRenderScore = () =>
    (!!this.props.localScore || this.props.localScore === 0) &&
    (!!this.props.visitorScore || this.props.visitorScore === 0)

  shouldRenderSecondaryScore = () =>
    (!!this.props.localSecondaryScore || this.props.localSecondaryScore === 0) &&
    (!!this.props.visitorSecondaryScore || this.props.visitorSecondaryScore === 0)

  renderScore = () => (
    <div
      aria-label={`Marcador: ${this.props.localScore} contra ${this.props.visitorScore}`}
      className={classnames(styles.scoreColumns, styles.score)}
    >
      <div aria-hidden>
        <div>
          <div aria-hidden className={styles.hidden}>
            {this.props.visitorScore}
          </div>
          {this.props.localScore}
        </div>
        <div>~</div>
        <div>
          <div aria-hidden className={styles.hidden}>
            {this.props.localScore}
          </div>
          {this.props.visitorScore}
        </div>
      </div>
    </div>
  )

  renderSecondaryScore = () => (
    <div
      aria-label={`En reposición: ${this.props.localSecondaryScore} contra ${this.props.visitorSecondaryScore}`}
      className={classnames(styles.scoreColumns, styles.score, styles.scoreSecondary)}
    >
      <div aria-hidden>
        <div>
          <div aria-hidden className={styles.hidden}>
            ({this.props.visitorSecondaryScore})
          </div>
          ({this.props.localSecondaryScore})
        </div>
        <div>~</div>
        <div>
          <div aria-hidden className={styles.hidden}>
            ({this.props.localSecondaryScore})
          </div>
          ({this.props.visitorSecondaryScore})
        </div>
      </div>
    </div>
  )

  render() {
    const {
      children,
      className,
      localImage,
      localName,
      onLocalClick,
      onVisitorClick,
      scoreClassName,
      visitorImage,
      visitorName,
    } = this.props

    return (
      <div className={classnames(styles.scoreColumns, className)}>
        <div>
          <div>
            <div aria-hidden className={styles.hidden}>
              <TeamButton disabled name={visitorName} visitor />
            </div>
            <TeamButton image={localImage} name={localName} onClick={onLocalClick} />
          </div>
          <div className={scoreClassName}>
            {this.shouldRenderScore() && this.renderScore()}
            {this.shouldRenderSecondaryScore() && this.renderSecondaryScore()}
            {children}
          </div>
          <div>
            <div aria-hidden className={styles.hidden}>
              <TeamButton disabled name={localName} />
            </div>
            <TeamButton image={visitorImage} name={visitorName} onClick={onVisitorClick} visitor />
          </div>
        </div>
      </div>
    )
  }
}

MatchScore.propTypes = {
  localName: PropTypes.string.isRequired,
  visitorName: PropTypes.string.isRequired,

  children: ChildrenSchema,
  className: PropTypes.string,
  localImage: ImageSchema,
  localScore: ScoreSchema,
  localSecondaryScore: ScoreSchema,
  onLocalClick: PropTypes.func,
  onVisitorClick: PropTypes.func,
  scoreClassName: PropTypes.string,
  visitorImage: ImageSchema,
  visitorScore: ScoreSchema,
  visitorSecondaryScore: ScoreSchema,
}

MatchScore.defaultProps = {
  children: null,
  className: '',
  localImage: null,
  localScore: null,
  localSecondaryScore: null,
  onLocalClick: Function.prototype,
  onVisitorClick: Function.prototype,
  scoreClassName: '',
  visitorImage: null,
  visitorScore: null,
  visitorSecondaryScore: null,
}

export default MatchScore
